<aside
  class="fixed top-0 left-0 z-50 flex h-screen flex-col border-r border-gray-200 bg-white px-5 text-gray-900 transition-all duration-300 ease-in-out dark:border-gray-800 dark:bg-gray-900"
  [ngClass]="{
    'w-72.5': (isExpanded$ | async) || (isMobileOpen$ | async) || (isHovered$ | async),
    'w-22.5': !((isExpanded$ | async) || (isMobileOpen$ | async) || (isHovered$ | async)),
    'translate-x-0': isMobileOpen$ | async,
    '-translate-x-full': !(isMobileOpen$ | async),
    'xl:translate-x-0': true,
  }"
  (mouseenter)="onSidebarMouseEnter()"
  (mouseleave)="sidebarService.setHovered(false)"
>
  <div
    class="flex pt-2 pb-5"
    [ngClass]="{
      'xl:justify-center': !((isExpanded$ | async) || (isHovered$ | async)),
      'justify-start': (isExpanded$ | async) || (isHovered$ | async),
    }"
  >
    <a routerLink="/dashboard">
      @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
        <img class="dark:hidden" src="/images/logo/logo.png" alt="Logo" width="150" height="40" />
      } @else {
        <img src="/images/logo/logo-icon.png" alt="Logo" width="32" height="32" />
      }
    </a>
  </div>

  <div class="no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear">
    <nav class="mb-6">
      <div class="flex flex-col gap-4">
        <ul class="flex flex-col gap-1">
          @for (nav of navItems; track $index; let i = $index) {
            <li>
              @if (nav.subItems) {
                <button
                  (click)="toggleSubmenu('main', i)"
                  class="menu-item group cursor-pointer"
                  [class.menu-item-active]="isParentActive(nav)"
                  [class.menu-item-inactive]="!isParentActive(nav)"
                  [ngClass]="{
                    'xl:justify-center': !((isExpanded$ | async) || (isHovered$ | async)),
                    'xl:justify-start': (isExpanded$ | async) || (isHovered$ | async),
                  }"
                >
                  <span
                    class="menu-item-icon-size flex items-center justify-center overflow-visible"
                    [class.menu-item-icon-active]="isParentActive(nav)"
                    [class.menu-item-icon-inactive]="!isParentActive(nav)"
                  >
                    <ng-icon name="{{ nav.iconName }}" size="20" class="shrink-0" />
                  </span>
                  @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
                    <span class="menu-item-text">
                      {{ nav.name | translate }}
                    </span>
                  }
                  @if ((isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)) {
                    <ng-icon
                      name="hugeArrowDown01"
                      size="20"
                      class="ml-auto h-5 w-5 text-current transition-transform duration-200"
                      [ngClass]="{
                        'text-system-500 rotate-180': openSubmenu === 'main-' + i,
                      }"
                    />
                  }
                </button>
                <div
                  class="overflow-hidden transition-all duration-300"
                  [id]="'main-' + i"
                  [style.display]="
                    (isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)
                      ? 'block'
                      : 'none'
                  "
                  [ngStyle]="{
                    height:
                      openSubmenu === 'main-' + i
                        ? (subMenuHeights['main-' + i] || 0) + 'px'
                        : '0px',
                  }"
                >
                  <ul class="mt-2 ml-5 space-y-1">
                    @for (subItem of nav.subItems; track $index) {
                      <li>
                        <a
                          [routerLink]="subItem.path"
                          routerLinkActive=""
                          (click)="onSubmenuClick()"
                          class="menu-dropdown-item"
                          [ngClass]="{
                            'menu-dropdown-item-inactive': !isChildActive(subItem.path),
                            'menu-dropdown-item-active': isChildActive(subItem.path),
                          }"
                        >
                          <span
                            class="flex h-5 w-5 items-center justify-center text-gray-500 dark:text-gray-400"
                          >
                            <ng-icon name="{{ subItem.iconName }}" size="20" />
                          </span>
                          <span class="ml-0">
                            {{ subItem.name | translate }}
                          </span>
                          <span class="ml-auto flex items-center gap-1"> </span>
                        </a>
                      </li>
                    }
                  </ul>
                </div>
              } @else {
                @if (nav.path) {
                  <a
                    [routerLink]="nav.path"
                    class="menu-item group"
                    [ngClass]="{
                      'menu-item-active': isParentActive(nav),
                      'menu-item-inactive': !isParentActive(nav),
                    }"
                    (click)="onSingleMenuClick()"
                  >
                    <span
                      class="menu-item-icon-size flex items-center justify-center overflow-visible"
                      [class.menu-item-icon-active]="isParentActive(nav)"
                      [class.menu-item-icon-inactive]="!isParentActive(nav)"
                    >
                      <ng-icon name="{{ nav.iconName }}" size="20" class="shrink-0" />
                    </span>
                    <span class="menu-item-text">
                      @if (
                        (isExpanded$ | async) || (isHovered$ | async) || (isMobileOpen$ | async)
                      ) {
                        {{ nav.name | translate }}
                      }
                    </span>
                  </a>
                }
              }
            </li>
          }
        </ul>

        <!-- end other section -->
      </div>
    </nav>
  </div>
</aside>
